
seedWebControllers.controller('EditIntegrationAppConfigCtrl', ['$scope', '$window','$uibModal', '$timeout', 'IntegrationAppService', 'TranslationService', '$uibModalInstance',
    function ($scope, $window, $uibModal, $timeout, IntegrationAppService, TranslationService, $uibModalInstance) {

        $scope.translation = TranslationService.getActiveTranslation();

        $scope.integrationAppConfig = {
            IntegrationAppConfigID: '',
            JsonConfig: 'Aguarde, carregando...'
        };

        var loadConfig = function () {
            $scope.error = false;
            $scope.loading = true;

            IntegrationAppService.get({}, function (data) {
                if (data) {
                    $scope.integrationAppConfig = data;
                } else {
                    $scope.integrationAppConfig = IntegrationAppService.appConfigModel;
                }
                $scope.loading = false;
            }, function (errorDescription) {
                $scope.loading = false;
                $scope.error = true;
                $scope.errorDescription = errorDescription;
            });
        };

        loadConfig();

        $scope.openUibModal = function (templateUrl, size) {
            $uibModal.open({
                animation: true,
                templateUrl: templateUrl,
                size: size,
                resolve: {
                    integrationAppConfig: function () { return $scope.integrationAppConfig.JsonConfig; },
                }
            });
        };

        $scope.saveAndClose = function () {
            $scope.loadingSave = true;

            IntegrationAppService.save($scope.integrationAppConfig, function () {
                IntegrationAppService.resetCache();
                $uibModalInstance.close();
                $scope.loadingSave = false;
            });
        };

        $scope.ok = function () {
            $scope.loading = true;

            IntegrationAppService.save($scope.integrationAppConfig, function () {
                IntegrationAppService.resetCache();
                $scope.loading = false;
            });
        };

        $scope.cancel = function () {
            $scope.closedModal = true;
            $uibModalInstance.dismiss($scope.closedModal);
        };

        $scope.getWindowHeight = function () {
            var innerHeight = Math.max(0, window.innerHeight);
            var headerHeight = 215;
            var height = innerHeight - headerHeight; //JRM: desconta header
            return height;
        };

        $scope.AdjustSize = function () {
            var innerHeight = Math.max(0, window.innerHeight);

            var headerHeight = 215;

            var height = innerHeight - headerHeight; //JRM: desconta header

            if (document.getElementById('SourceMappings')) {
                document.getElementById('SourceMappings').style.height = height + 'px';
            }

            if (document.getElementById('AfterDecodeScript')) {
                document.getElementById('AfterDecodeScript').style.height = height + 'px';
            }

            if (document.getElementById('Sample')) {
                document.getElementById('Sample').style.height = height + 'px';
            }

            if ($scope.myCodeMirror) {
                $scope.myCodeMirror.setSize(null, height);
                $scope.myCodeMirror.refresh();
            }
        };

        var w = angular.element($window);
        $scope.$watch(function () {
            return {
                'h': w.height(),
                'w': w.width()
            };
        }, function (newValue) {
            $scope.windowHeight = newValue.h;
            $scope.windowWidth = newValue.w;
            $scope.AdjustSize();
        }, true);

        $scope.selectEditor = function (index) {
            var cmScript = $('.CodeMirror')[index].CodeMirror;
            var height = $scope.getWindowHeight();
            cmScript.setSize(null, height);
            $timeout(function () {
                cmScript.refresh();
            });
        };
    }
]);
